import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className={`font-heading text-2xl ${scrolled ? 'text-primary-500' : 'text-background-50'}`}>
              虫虫漫画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                isActive('/')
                  ? scrolled ? 'text-primary-500' : 'text-background-50'
                  : scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/hanman"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? scrolled ? 'text-primary-500' : 'text-background-50'
                  : scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              分类
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                isActive('/about')
                  ? scrolled ? 'text-primary-500' : 'text-background-50'
                  : scrolled ? 'text-foreground-700 hover:text-primary-500' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm transition-colors ${
              scrolled ? 'bg-background-100 text-foreground-600' : 'bg-background-50/20 text-background-50/70'
            }`}>
              <i className="ri-search-line text-sm w-4 h-4 flex items-center justify-center"></i>
              <input
                type="text"
                placeholder="搜索漫画..."
                className={`bg-transparent outline-none w-32 text-sm placeholder:${
                  scrolled ? 'text-foreground-400' : 'text-background-50/50'
                }`}
              />
            </div>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled ? 'text-foreground-700' : 'text-background-50'
            }`}
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 cursor-pointer whitespace-nowrap">首页</Link>
            <Link to="/category/hanman" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 cursor-pointer whitespace-nowrap">分类</Link>
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 cursor-pointer whitespace-nowrap">关于我们</Link>
            <div className="flex items-center gap-2 px-3 py-2 rounded-full bg-background-100">
              <i className="ri-search-line text-sm text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
              <input type="text" placeholder="搜索漫画..." className="bg-transparent outline-none w-full text-sm placeholder:text-foreground-400" />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}